export default {
  isLoading: state => state.isLoading,
  lastCallElementToOnBlur: state => state.lastCallElementToOnBlur
};
